import { useEffect, FC } from "react";
import {
  useNavigate,
  UseNavigateOptions,
} from "@Libs/Router/hooks/useNavigate";
import { IGenerateRouteKey } from "@Libs/Router/Contexts/RoutesContext";
import { IAppRoute } from "@App/types";

export interface NavigateProps extends UseNavigateOptions {
  to?: IGenerateRouteKey;
}

const isIAppRouteIterator = (
  route: IGenerateRouteKey
): route is IAppRoute | IAppRoute[] => {
  return Array.isArray(route) || typeof route === "string";
};

export const mergeNavigateProps = (
  baseProps: NavigateProps,
  props: NavigateProps
): NavigateProps => {
  let to: NavigateProps["to"];

  if (isIAppRouteIterator(baseProps.to)) {
    if (isIAppRouteIterator(props.to)) {
      to = [...baseProps.to, ...props.to] as NavigateProps["to"];
    } else if (props?.to?.fragments) {
      to = {
        ...props.to,
        fragments: [...baseProps.to, ...props.to.fragments],
      } as NavigateProps["to"];
    } else {
      to = {
        ...props.to,
        fragments: [...baseProps.to],
      } as NavigateProps["to"];
    }
  } else {
    if (isIAppRouteIterator(props.to)) {
      to = {
        ...baseProps.to,
        fragments: [...baseProps.to.fragments, ...props.to],
      } as NavigateProps["to"];
    } else if (props?.to?.fragments) {
      to = {
        ...baseProps.to,
        ...props.to,
        fragments: [...baseProps.to.fragments, ...props.to.fragments],
      } as NavigateProps["to"];
    } else {
      to = {
        ...baseProps.to,
        ...props.to,
      } as NavigateProps["to"];
    }
  }

  return {
    ...baseProps,
    ...props,
    to,
  };
};

export const Navigate: FC<NavigateProps> = ({ to, ...props }) => {
  const navigate = useNavigate();

  useEffect(() => {
    navigate(to, props);
  }, [navigate, to, props]);

  return null;
};
